import { render, staticRenderFns } from "./ChoirMinstryManagePage.vue?vue&type=template&id=47599123&scoped=true&"
import script from "./ChoirMinstryManagePage.vue?vue&type=script&lang=js&"
export * from "./ChoirMinstryManagePage.vue?vue&type=script&lang=js&"
import style0 from "./ChoirMinstryManagePage.vue?vue&type=style&index=0&id=47599123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47599123",
  null
  
)

export default component.exports